<template>
  <div id="contendor-principal-administracionSentencias" style="position:relative;">
    <div id="contenedor-encabezados-administracionSentencias" class="text-left">
      <h1>SENTENCIAS</h1>
      <h3 v-if="Laboral" style="color: black">Baja y Cambios de Sentencias</h3>
      <h3 v-else style="color: black">Alta, Baja y Cambios de Sentencias</h3>
    </div>
    <div id="contendor-principal-sentencias" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      <div v-if="(obtenerAreaDeUsuario!= undefined && obtenerAreaDeUsuario!= null) || (Oralidad)" v-show="!mostrarFormularioInformacionSentencia" id="contenedor-filtros-consulta" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">      
        <div v-bind:class="[ mostrarFormularioInformacionSentencia ? 'wrapDivBloqueado': '']">
          <div v-bind:class="[ mostrarFormularioInformacionSentencia ? 'area bloquearDiv': 'area']" style="background-color:#bebebc">
            <FiltrosDeBusqueda 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :elementosAConservar ="elementosAConservar"
                :AccionesMostrar="comportamientoFiltroDeBusqueda"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarExpedienteAPI"  
                :area="obtenerAreaDeUsuario"
                :esOralidad="Oralidad"
                :tituloDeBusqueda="'Búsqueda del expediente'"              
                :ref="'filtroBusqueda'">
            </FiltrosDeBusqueda>
          </div>
        </div>             
      </div>
      </transition>
      <!-- Tabla de resultados e Información de sentencia -->
      <div  v-bind:class="[mostrarFormularioInformacionSentencia? 'col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12':'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0']" id="ExpedientesEncontradosSentencias_div">
        <div v-bind:class="[((expedientes == undefined || expedientes == null || expedientes.length <= 0) && !mostrarFormularioInformacionSentencia) ? 'areaLocal' : 'areaLocal gris-claro']">
          <transition name="fade">
          <div v-if="(expedientes == undefined || expedientes == null || expedientes.length <= 0) && !mostrarFormularioInformacionSentencia" style="background-color:#bebebc;padding: 8px;">
            <div class="d-flex justify-content-center">
              <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px;color:black"></i>
              <div class="align-content-center">
                <h5 style="color: black">Expedientes encontrados</h5>
              </div>
            </div>
          </div>
          <TablaDeResultados 
            v-else-if="expedientes != undefined && expedientes != null  || expedientes.length <= 0"
            v-show="!mostrarFormularioInformacionSentencia"
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="AccionesTabla"
            :Expedientes="expedientes"
            :EsConsulta="false">
          </TablaDeResultados>
          </transition>
          <transition name="fade">
          <InformacionSentencia 
            v-if="mostrarFormularioInformacionSentencia"
            v-on:cancelarAltaCambios="cancelarAltaCambiosAPI"
            v-on:testarSentencia="configurarVisorParaTestarYMostrar"
            v-on:visualizarSentencia="configurarVisorParaVisualizarYMostrar"
            v-on:guardar="guardarAltaCambiosSentenciaAPI"
            v-on:subirArchivo="subirArchivoAPI"
            :esAlta="!Sentencia.EsInformacionDesdeDBSICSEN"
            :sentencia="Sentencia"
            :esWord="this.AccionesTabla.altaWord"
            :tituloDeInformacion="tituloDeInformacionDeSentencia"
            :ref="'informacionSentencia'">
          </InformacionSentencia>
          </transition>
        </div>  
      </div> 
    </div>
    <!-- Visor/Testeo de Sentencia -->
    <VisorTesteoSentencia
      v-if="mostrarVisorTestarSentencia && obtenerRutaArchivoFinal != undefined"
      :esTesteo="esTesteo"
      :listadoPalabrasFrasesATestar="listadoPalabrasFrasesDeSentencia"
      :leyendaDeSentencia="Sentencia.LeyendaDeSentenciaPublica" 
      :consecutivoDeExpediente="Expediente.Consecutivo"
      :EsBase64="EsBase64"
      :keyVisor="keyVisor"
      v-on:cancelar="cancelarAltaCambiosAPI"
      v-on:testarArchivo="testarArchivoAPI(false)"
      v-on:regresar="regresarDesdeVisor"
      v-on:guardar="guardarAltaCambiosSentenciaAPI"
      v-on:subirArchivo="subirArchivoAPI"
      :ref="'visorTesteoSentencia'">
    </VisorTesteoSentencia>
  </div>
</template>

<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import FiltrosDeBusqueda from '@/components/SICSEN/Comun/FiltroDeBusqueda.vue'
  import InformacionSentencia from '@/components/SICSEN/Administracion/InformacionSentencia.vue'
  import TablaDeResultados from '@/components/SICSEN/Comun/TablaDeResultados.vue'
  import VisorTesteoSentencia from '@/components/SICSEN/Comun/VisorTesteoSentencia.vue'
  import moment from 'moment'

  export default {
    components: {
      FiltrosDeBusqueda,
      InformacionSentencia,
      TablaDeResultados,
      VisorTesteoSentencia
    },
    data(){
      return{
        keyVisor:0,
        EsBase64:{},
        enumeraciones,
        tituloDeInformacionDeSentencia:'',
        mostrarFormularioInformacionSentencia:false,
        mostrarVisorTestarSentencia: false, //Se requiere en consulta
        esTesteo:false,
        listadoPalabrasFrasesDeSentencia: [],
        leyendaDeSentenciaParaVisor:"",
        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Sentencias' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda-NoExtra-Sentencias' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' },
          { catalogoId: enumeraciones.catalogos.Juicios, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Juicio' }
        ],
        expedientes: null,
        AccionesTabla:{
          alta: true,
          altaWord: false,
          baja: true,
          cambios: true,
          visualizacion: true,
          agregar: true
        },
        elementosAOmitir: {
          materias: [5,10] //áreas de Majat
        },
        elementosAConservar: {},
        comportamientoFiltroDeBusqueda:{            
          administracion: true,
          consulta: false
        },
        Sentencia: null,
        Expediente: null,
        Laboral: false,
        Oralidad: false,
        Penal: false,
        BorrarRutasCuandoSeaAgregar: false,
        Usuario: {
          usuarioId: null,
          permisos: []
        }             
      }
    },
    computed: {
      /**
       * Funcion encargadas de obtener area del usuario de store.
       */
      obtenerAreaDeUsuario() {

        if(this.$store.getters.Get_AreaDelUsuario != undefined || this.$store.getters.Get_AreaDelUsuario != null){
          if(this.$store.getters.Get_AreaDelUsuario.AreaId == 96 || this.$store.getters.Get_AreaDelUsuario.AreaId == 97)
              this.Laboral = true;
        } 

        if(this.$store.getters.Get_AreaDelUsuario.AreaId == 48 || this.$store.getters.Get_AreaDelUsuario.AreaId == 51 || this.$store.getters.Get_AreaDelUsuario.AreaId == 52 ||
           this.$store.getters.Get_AreaDelUsuario.AreaId == 53 || this.$store.getters.Get_AreaDelUsuario.AreaId == 54)
        {
          this.Oralidad = true;  
          this.elementosAConservar = {
            areas: [48,51,52,53,54]
          }                 
          return null;
        }
          
        return this.$store.getters.Get_AreaDelUsuario;
      },
      /**
       * Funcion encargadas de obtener la ruta del archivo PDF de la sentencia.
       */
      obtenerRutaArchivoFinal() {
          return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal;
      },
      /**
       * Funcion encargadas de obtener la ruta del archivo DOC de la sentencia.
       */
      obtenerRutaArchivoOrigen() {
          return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen;
      },
      /**
       * Funcion encargadas de obtener la ruta del archivo DOC testado de la sentencia.
       */
      obtenerRutaWordTestado() {
          return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado;
      }
    },
    /**
     * Función router. Se valida si se está dando de alta o editando una sentencia y
     * se llama al API para eliminar los archivos marcados como "EnEdicion".
     */
    beforeRouteLeave (to, from, next) {
      if(this.mostrarFormularioInformacionSentencia) {
          this.cancelarAltaCambiosAPI(next);
      } else {
        next();
      }
    },
    methods: {
      /** 
       * Metodo encargado de verificar que todos los campos para la búsqueda estén llenos
       * @param {object} datos [datos de filtro de búsqueda]
       */
      validarDatosBusquedaExpediente: function(datos)
      {
        if (datos.PartidoJudicialId == null || datos.PartidoJudicialId == -1) { //Verifica partido judicial
          comun.mensajeDeAlerta("Favor de indicar el partido judicial.", null, null);
          return false;
        }
        if (datos.AreaId == null || datos.AreaId == -1) { //Verifica área
          comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
          return false;
        }
        if (datos.MateriaId == null || datos.MateriaId == -1) { //Verifica Materia
          comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
          return false;
        }
        
        if (datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1) { //verifica tipo de documento
          comun.mensajeDeAlerta("Favor de indicar el tipo de documento.", null, null);
          return false;
        }
        /*if (datos.NumeroDocumento == null || datos.NumeroDocumento == undefined || datos.NumeroDocumento == "") {
          comun.mensajeDeAlerta("Favor de indicar el consecutivo.", null, null);
          return false;
        }*/
        if (this.$refs['filtroBusqueda'].baseDeDatosId != 3 &&
            (datos.NumeroDocumento == null || datos.NumeroDocumento == undefined || datos.NumeroDocumento == "") && 
            (datos.Año == null || datos.Año == undefined || datos.Año == "" )) { //Verifica haya consecutivo o año
          comun.mensajeDeAlerta("Favor de indicar el consecutivo o el año.", null, null);
          return false;
        }
        else if (this.$refs['filtroBusqueda'].baseDeDatosId != 3 && (datos.NumeroDocumento && datos.NumeroDocumento.length < 9)) { //Verifica consecutivo
          comun.mensajeDeAlerta("Favor de indicar el consecutivo completo.", null, null);
          return false;
        }
        else if (this.$refs['filtroBusqueda'].baseDeDatosId != 3 && datos.Año && (parseInt(datos.Año) < 1990 || parseInt(datos.Año) > moment().year()) &&
        (datos.NumeroDocumento == null || datos.NumeroDocumento == undefined || datos.NumeroDocumento == "")) { //Verifica año
          comun.mensajeDeAlerta("Favor de indicar un valor de año válido.", null, null);
          return false;
        }

        if(this.$refs['filtroBusqueda'].baseDeDatosId == 3 && (datos.DocumentoNoPadreId == null || datos.DocumentoNoPadreId <= 0)){ //Verifica folio del acuerdo para consultas a SIOP
          comun.mensajeDeAlerta("Favor de indicar el folio del acuerdo.", null, null);
          return false;
        }
        return true;
      }, 
      /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      /** 
       * Metodo encargado de ocultar visor y llamar función Testar si es necesario.
       */
      regresarDesdeVisor: function()
      {
        this.mostrarVisorTestarSentencia = false; 
        if(this.esTesteo)
          this.testarArchivoAPI(true);
      },
      /** 
       * Metodo encargado de limpiar los valores de sentencia, expediente y rutas de archivos.
       */
      limpiarValores: function()
      {
        this.Expediente = null;
        this.Sentencia = null;
        this.cambioRutaArchivoFinal(null);
        this.cambioRutaArchivoOrigen(null);
        this.cambioRutaWordTestado(null);
        this.BorrarRutasCuandoSeaAgregar = false;
      },
      /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.expedientes = null;
      },
      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, baja, cambios, visualizar)
       * en la tabla de resultados, además de proporcionar el expediente y sentencia correspondiente a esa acción.
       * @param {object} datos [datos: Sentencia,Expediente,Accion{Alta, Baja, Cambios, Visualizar}]
       */
      accionRealizar:function(datos)
      {
        this.limpiarValores();
        //Asignar/generar copia de Sentencia y Expediente proporcionados
        this.Sentencia = Object.assign({}, datos.Sentencia);
        if(datos.Sentencia.Delitos)
        {
          this.Sentencia.Delitos = [];
          datos.Sentencia.Delitos.forEach(delito=> this.Sentencia.Delitos.push(Object.assign({}, delito)));
        }
        this.Expediente = Object.assign({}, datos.Expediente);

        //Si existen archivos se asignan en el store
        if(this.Sentencia.ExisteArchivoOrigen)
          this.cambioRutaArchivoOrigen(this.Sentencia.ArchivoOriginalRuta);
        if(this.Sentencia.ExisteArchivoFinal)
          this.cambioRutaArchivoFinal(this.Sentencia.ArchivoFinalRuta);          
        
        //Alta de sentencia, activa componente y proporciona un título
        if(datos.Accion.Alta || datos.Accion.Agregar)
        {
          if(datos.Accion.Agregar/* && this.Penal*/)
          {            
              this.Sentencia.ExisteArchivoOrigen = null;
              this.Sentencia.ExisteArchivoFinal = null;
              this.Sentencia.SentenciaId =  null;         
              this.Sentencia.ArchivoOriginalRuta = null;
              this.Sentencia.ArchivoFinalRuta = null;
              this.BorrarRutasCuandoSeaAgregar = true;
          }

          this.tituloDeInformacionDeSentencia = "Ingrese la información para dar de alta la sentencia";
          this.generarCopiaDeArchivosDeSentenciaAPI();
        }
        //Baja de sentencia
        else if(datos.Accion.Baja)
        {
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por eliminar una sentencia, si decide continuar no recuperar dicha sentencia. <br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Eliminar'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                this.eliminarSentenciaAPI();
              }
            }
          });
        }
        //Editar información de sentencia
        else if(datos.Accion.Cambios)
        {
          this.tituloDeInformacionDeSentencia = "Edite la información o testee el documento para guardar la sentencia";
          this.generarCopiaDeArchivosDeSentenciaAPI();
        }
        //Visualizar una sentencia
        else if(datos.Accion.Visualizar) 
        {
          if(this.obtenerRutaArchivoFinal && this.obtenerRutaArchivoFinal != "")
          {
            //this.esTesteo = false;
            //this.mostrarVisorTestarSentencia = true;            
            this.obtieneBase64(this.Sentencia.ArchivoFinalRuta, true);
            //this.configurarVisorParaVisualizarYMostrar();
          }
        }
      },      
      obtieneBase64: async function(archivoFinalRuta, configurarVisorParaVisualizarYMostrar, visualizarDespuesDeTestar)
      {
        const parametros = { 
              ArchivoFinalRuta: archivoFinalRuta
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
        await  axios.post(api.conexion + api.SICSEN.sistema.consulta.consultaPublicaSentencias.ConvierteBase64, parametros, headerPeticion)
          .then(respuesta => {                         
            if (respuesta.data.SiHayError) {              
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);      
            } 
            if(respuesta.data.ArchivoBase64 != null){              
              this.EsBase64 = {
                  esBase64: true,
                  archivoBase64: respuesta.data.ArchivoBase64
              }    
              if(configurarVisorParaVisualizarYMostrar){
                this.esTesteo = false;
                this.mostrarVisorTestarSentencia= true;
              }
              if(visualizarDespuesDeTestar){
                this.configurarVisorParaTestarYMostrar();
              }              
              this.keyVisor++;
            }
                      
          })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },
      /** 
       * Metodo encargado de asignar valores props para configurar el visor para testar el documento una sentencia.
       */
      configurarVisorParaTestarYMostrar:function()
      {
        this.listadoPalabrasFrasesDeSentencia = this.Sentencia.PalabrasFrasesATestar != null ? this.Sentencia.PalabrasFrasesATestar.split("¶"): [];
        this.esTesteo = true;
        if(!this.obtenerRutaArchivoFinal && this.Sentencia.ExisteArchivoOrigen){
          this.testarArchivoAPI(false);
        }
        this.mostrarVisorTestarSentencia= true;
      },
      /** 
       * Metodo encargado de asignar valores props para configurar el visor para visualizar el documento de una sentencia.
       */
      configurarVisorParaVisualizarYMostrar:function()
      {
        this.esTesteo = false;
        this.mostrarVisorTestarSentencia= true;
      },
      /** 
       * Metodo encargado de limpiar valores cuando se cierra el visor.
       */
      cerrarVisor:function()
      {
        if(!mostrarFormularioInformacionSentencia)
        {
          this.limpiarValores();
        }
        this.mostrarVisorTestarSentencia = false;
      },
      /** 
       * Metodo encargado de llamar API para búscar un expediente en base a los datos proporcionados.
       */
      buscarExpedienteAPI:function() 
      { 

        this.Usuario.usuarioId = this.$store.state.Login_Usuario.UsuarioId;

        const parametrosAcciones = {
          UsuarioId: this.Usuario.usuarioId                 
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
        axios.post(api.conexion + api.SICSEN.sistema.administracion.sentencias.PermisosAcciones, parametrosAcciones, headerPeticion)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.AccionesTabla.alta = true; 
              this.AccionesTabla.altaWord = false;
              
            } else {              
              console.log(respuesta.data.accionesId);
              this.Usuario.permisos = respuesta.data.accionesId;     
              const accionSubirSoloWORD = 2;
              if(this.Usuario.permisos.includes(accionSubirSoloWORD))
              {
                this.AccionesTabla.altaWord = true; 
                this.AccionesTabla.alta = false; 
              }
            }         
          })
          .catch(e => {            
            console.log("ERROR:" + e);
            this.AccionesTabla.alta = true; 
            this.AccionesTabla.altaWord = false;
          });

        const parametros = 
        {    
          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          NumeroDocumento: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
          Año: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].anio) ? this.$refs['filtroBusqueda'].anio : null,
          NumeroExtra: this.$store.state.Comun_NumeroExtra,
          NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'.numeroRomano]) ? this.$refs['filtroBusqueda'.numeroRomano] : null,
          NumeroCarpetaJuicio: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'.numeroCarpeta]) ? this.$refs['filtroBusqueda'.numeroCarpeta] : null,
          SentenciaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].folioSentencia) ? this.$refs['filtroBusqueda'].folioSentencia : null,
          DocumentoNoPadreId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].folioAcuerdo) ? this.$refs['filtroBusqueda'].folioAcuerdo : null,
          JuicioId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Juicio.juicioId) ? this.$refs['filtroBusqueda'].parametros_Juicio.juicioId : null,
          DelitoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Delito.delitoId) ? this.$refs['filtroBusqueda'].parametros_Delito.delitoId : null,
          TipoResolucionId: null,
          // Se quito ésta linea porque ya no estará este filtro para admin. -> TipoResolucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoResolucion.tipoResolucionId) ? this.$refs['filtroBusqueda'].parametros_TipoResolucion.tipoResolucionId : null,
          FechaDeDictado: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaDeDictado) ? this.$refs['filtroBusqueda'].fechaDeDictado : null,
          EsPrueba: this.enumeraciones.EsPrueba
        }
        /*if(parametros.MateriaId == 6 || parametros.MateriaId == 9)  //6 = MATERIA PENAL, 9 = MATERIA ORAL PENAL
        {
            this.Penal = true;
            this.AccionesTabla.agregar = true;        
        }
         else
            this.Penal = false;*/

        if(this.validarDatosBusquedaExpediente(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SICSEN.sistema.administracion.sentencias.BuscarExpediente, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              //console.log(respuesta.data.Expedientes);
              //CargarDatos de expediente
              this.expedientes = respuesta.data.Expedientes;
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);              
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },
      /** 
       * Metodo encargado de llamar API para generar una copia de los archivos de sentencia para su edición.
       */
      generarCopiaDeArchivosDeSentenciaAPI:function()
      {        
        if(this.Sentencia.ExisteArchivoOrigen || this.Sentencia.ExisteArchivoFinal)
        {
          const parametros = 
          {    
            Sentencia: this.Sentencia,
            MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
            AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
            EsPrueba: this.enumeraciones.EsPrueba
          }

          //console.log("Copia de archivo de sentencia: ", this.Sentencia);
          
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SICSEN.sistema.administracion.sentencias.GenerarCopiaArchivoSentenciaParaEdicion, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError && !respuesta.data.Error.Mensaje.includes("no tiene archivos existentes")) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Sentencia = respuesta.data.Sentencia;
              if(this.Sentencia.ArchivoFinalRuta){
                this.cambioRutaArchivoFinal(this.Sentencia.ArchivoFinalRuta);
                this.obtieneBase64(this.Sentencia.ArchivoFinalRuta,false);
              }         
              
              if(this.Sentencia.ArchivoOriginalRuta)
                this.cambioRutaArchivoOrigen(this.Sentencia.ArchivoOriginalRuta);
              this.mostrarFormularioInformacionSentencia= true;
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
        else this.mostrarFormularioInformacionSentencia= true;
      },
      /** 
       * Metodo encargado de llamar a API para subir un archivo
       * @param {bool} guardarDespuesDeSubirArchivo [guardarDespuesDeSubirArchivo: Determina si después de subir un archivo se debe llamar a la función de guardado]
       */
      subirArchivoAPI:function(guardarDespuesDeSubirArchivo, visorPdf)
      {        
        let peticionArchivo = new FormData();
        //Obtener rutas anteriores para eliminar los archivos rezagados.
        let rutasAnteriores = [];
        if(!this.BorrarRutasCuandoSeaAgregar/* && !this.Penal*/)
        {         
          if(this.obtenerRutaArchivoOrigen)
            rutasAnteriores.push(this.obtenerRutaArchivoOrigen);
          if(this.obtenerRutaArchivoFinal)
            rutasAnteriores.push(this.obtenerRutaArchivoFinal);
          if(this.obtenerRutaWordTestado)
            rutasAnteriores.push(this.obtenerRutaWordTestado);
        }
          
        //Construir petición y header
        comun.SeEstaCargandoInformacion(true); 
        peticionArchivo.append('EsPrueba', this.enumeraciones.EsPrueba);
        peticionArchivo.append('RutasAnteriores', rutasAnteriores.length > 0 ? rutasAnteriores : null );
        peticionArchivo.append('AreaId', this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null );
        peticionArchivo.append('MateriaId', this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null );
        peticionArchivo.append('SentenciaId', this.Sentencia != null && this.Sentencia.SentenciaId != undefined && this.Sentencia.SentenciaId != null && this.Sentencia.SentenciaId > 0 ? this.Sentencia.SentenciaId : null );
        peticionArchivo.append('EsWord', this.AccionesTabla.altaWord);

        if(visorPdf)
          peticionArchivo.append("Archivo", this.$refs['visorTesteoSentencia'].archivoPdf);          
        else
          peticionArchivo.append("Archivo", this.$refs['informacionSentencia'].DOCUMENTO_SENTENCIA);          
        
        peticionArchivo.append('visorPdf', visorPdf);

        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true);  
        
        //Llamado a API
        axios.post(
          api.conexion + api.SICSEN.sistema.administracion.sentencias.SubirArchivo, 
          peticionArchivo, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.Sentencia.PalabrasFrasesATestar = null;
            this.Sentencia.ArchivoOriginalRuta = null;
            this.Sentencia.ArchivoFinalRuta = null;
            this.cambioRutaArchivoOrigen(null);
            this.cambioRutaArchivoFinal(null);
            if(this.AccionesTabla.alta){
              if(respuesta.data.RutaArchivoPDF)
              {
                this.cambioRutaArchivoFinal(respuesta.data.RutaArchivoPDF);              
                this.Sentencia.ArchivoFinalRuta = respuesta.data.RutaArchivoPDF;             
                this.obtieneBase64(this.Sentencia.ArchivoFinalRuta,true); 
                
                if(visorPdf){                
                  
                  this.cambioRutaArchivoOrigen(respuesta.data.RutaArchivoDOC);
                  this.Sentencia.ArchivoOriginalRuta = respuesta.data.RutaArchivoDOC;                               
                }

                if(guardarDespuesDeSubirArchivo)
                  this.guardarAltaCambiosSentenciaAPI(null);              
              }
              else
              {
                this.cambioRutaArchivoOrigen(respuesta.data.RutaArchivoDOC);
                this.Sentencia.ArchivoOriginalRuta = respuesta.data.ArchivoOriginalRuta;
                this.esTesteo = true;
                this.testarArchivoAPI(true, true);
              }
            }
            /* Agregado para el funcionamiento de NUEVA VERSION DE NO TESTEO DE ARCHIVOS */
            if(this.AccionesTabla.altaWord){
              this.cambioRutaArchivoOrigen(respuesta.data.RutaArchivoDOC);
              this.Sentencia.ArchivoOriginalRuta = respuesta.data.ArchivoOriginalRuta;
              this.cambioRutaArchivoFinal(respuesta.data.RutaArchivoPDF);
              this.Sentencia.ArchivoFinalRuta = respuesta.data.RutaArchivoPDF;
              this.guardarAltaCambiosSentenciaAPI(null);
            }
          }            
        })
        .catch(excepcion => {
          comun.SeEstaCargandoInformacion(false);
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
        
      },
      /** 
       * Metodo encargado de llamar a API para testar un documento
       */
      testarArchivoAPI:function(tomarListadoDeObjeto, visualizarDespuesDeTestar)
      {
        this.EsBase64={
        esBase64:null,
        archivoBase64:null
        };
        comun.SeEstaCargandoInformacion(true); 
        
        //Construir petición y header
        var listado = !tomarListadoDeObjeto ? (this.$refs['visorTesteoSentencia'] && this.$refs['visorTesteoSentencia'].listadoPalabrasFrasesATestar ? this.$refs['visorTesteoSentencia'].listadoPalabrasFrasesATestar : null): (this.Sentencia.PalabrasFrasesATestar != null ? this.Sentencia.PalabrasFrasesATestar.split("¶") : null);
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          RutaArchivo: this.obtenerRutaArchivoOrigen,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          PalabrasATestar: listado,
          LeyendaDeSentencia: this.$refs['visorTesteoSentencia'] && this.$refs['visorTesteoSentencia'].leyendaDeSentenciaTxtArea ? this.$refs['visorTesteoSentencia'].leyendaDeSentenciaTxtArea : this.Sentencia.LeyendaDeSentenciaPublica,
          Consecutivo: this.Expediente.Consecutivo,
          FechaDeDictado: this.$refs['informacionSentencia'].fechaDeDictado
        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);    

        //Llamado a API
        axios.post(
          api.conexion + api.SICSEN.sistema.administracion.sentencias.TestarSentencia, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.cambioRutaArchivoFinal(respuesta.data.RutaArchivoSentencia);
            this.cambioRutaWordTestado(respuesta.data.RutaWordTestado);
            console.log(respuesta);
            this.Sentencia.ArchivoFinalRuta = respuesta.data.RutaArchivoSentencia;
            this.Sentencia.LeyendaDeSentenciaPublica = respuesta.data.LeyendaDeSentencia;
            this.Sentencia.RutaWordTestado = respuesta.data.RutaWordTestado;
            let bandera = false;
            if(visualizarDespuesDeTestar == undefined){
              bandera = false;
              visualizarDespuesDeTestar = false;
            }
            this.obtieneBase64(this.Sentencia.ArchivoFinalRuta, bandera, visualizarDespuesDeTestar);
            
           /* if(visualizarDespuesDeTestar)
            {
              if((respuesta.data.Satisfactorio.includes("No se proporcionó")))
                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.configurarVisorParaTestarYMostrar();
              console.log("entre a validacion visualizarDespuesDeTestar");
            }*/
            /* 
            if(this.$refs['visorTesteoSentencia'])
              this.$refs['visorTesteoSentencia'].keyVisor += 1;
            */            
           this.keyVisor += 1;
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },
      /** 
       * Metodo encargado de deshabilitar los componentes y reiniciar valores al momento de calcelar el alta o cambios de una sentencia.
       */
      cancelarAltaCambiosAPI:function(next)
      {
        //Obtener las rutas de archivos a eliminar
        let rutasAEliminar = [];
        if(!this.BorrarRutasCuandoSeaAgregar/* && !this.Penal*/)
        {
          if(this.obtenerRutaArchivoOrigen)
            rutasAEliminar.push(this.obtenerRutaArchivoOrigen);
          if(this.obtenerRutaArchivoFinal)
            rutasAEliminar.push(this.obtenerRutaArchivoFinal);
          if(this.obtenerRutaWordTestado)
            rutasAEliminar.push(this.obtenerRutaWordTestado);
        }

        if(rutasAEliminar.length > 0)
        {
          comun.SeEstaCargandoInformacion(true); 
          //Construir petición y header
          let peticion = {
            EsPrueba: this.enumeraciones.EsPrueba,
            ArchivosAEliminar: rutasAEliminar
          };
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          //Llamado a API
          axios.post(
            api.conexion + api.SICSEN.sistema.administracion.sentencias.CancelarAltaCambiosSentencia, 
            peticion, 
            headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.cambioRutaArchivoFinal(null);
              this.cambioRutaArchivoOrigen(null);
              if(next != undefined)
                next();
            }            
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
        this.mostrarFormularioInformacionSentencia= false;
        this.mostrarVisorTestarSentencia = false;
        this.Sentencia = null;
        this.Expediente = null;
        this.BorrarRutasCuandoSeaAgregar = false;
      },
      /** 
       * Metodo encargado de llamar a API para guardar el alta o cambios realizados a una sentencia
       * @param {string} palabrasFrasesATestar [palabrasFrasesATestar: String de palabras agregadas para testar archivo]
       */
      guardarAltaCambiosSentenciaAPI:function(palabrasFrasesATestar)
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        this.actualizarDatosSentencia(palabrasFrasesATestar);
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          Sentencia: this.Sentencia,
          Expediente: this.Expediente,
          TipoDeResolucionId: this.$refs['informacionSentencia'].tipoResolucionId
        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SICSEN.sistema.administracion.sentencias.GuardarSentencia, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },
      /** 
       * Metodo encargado de llamar a API para eliminar una sentencia
       */
      eliminarSentenciaAPI:function()
      {
        comun.SeEstaCargandoInformacion(true); 

        //Contruir petición y header
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba,
          SentenciaId: this.Sentencia.SentenciaId,
          ExpedienteId: this.Expediente.ExpedienteId
        };
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

        //Llamado a API
        axios.post(
          api.conexion + api.SICSEN.sistema.administracion.sentencias.EliminarSentencia, 
          peticion, 
          headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.restablecerValoresDespuesDeGuardarOEliminar();
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }            
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        });
      },
      /**
         * Función encargada de actualizar la información editada de una sentencia
         * @param {string} palabrasFrasesATestar [palabrasFrasesATestar: String de palabras agregadas para testar archivo]
         */
      actualizarDatosSentencia(palabrasFrasesATestar)
      {
        //this.Sentencia.Delitos = this.$refs['informacionSentencia'].sentencia.Delitos;
        this.Sentencia.FechaDeDictado = this.$refs['informacionSentencia'].fechaDeDictado;
        this.Sentencia.ArchivoFinalRuta = this.obtenerRutaArchivoFinal;
        this.Sentencia.ArchivoOriginalRuta = this.obtenerRutaArchivoOrigen;
        if(this.$refs['visorTesteoSentencia'] && this.$refs['visorTesteoSentencia'].leyendaDeSentenciaTxtArea)
          this.Sentencia.LeyendaDeSentenciaPublica = this.$refs['visorTesteoSentencia'].leyendaDeSentenciaTxtArea;
        if(this.campoRequeridoEsValido(palabrasFrasesATestar))
          this.Sentencia.PalabrasFrasesATestar = palabrasFrasesATestar;
      },
      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {
        this.mostrarFormularioInformacionSentencia = false;
        this.mostrarVisorTestarSentencia = false;
        this.limpiarValores();
        this.limpiarTablaResultados();
        this.buscarExpedienteAPI();
      },
      /**
         * Función encargada de cambiar la ruta del archivo final (PDF)
         */
      cambioRutaArchivoFinal(ruta) 
      {
        this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal", ruta);
      },
      /**
         * Función encargada de cambiar la ruta del archivo original (DOC)
         */
      cambioRutaArchivoOrigen(ruta) 
      {
        this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen", ruta);
      },
      /**
         * Función encargada de cambiar la ruta del archivo word ya testado (DOC)
         */
      cambioRutaWordTestado(ruta) 
      {
        this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado", ruta);
      }
    }
  }
</script>

<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.gris-claro{
  background-color: var(--gris-pj-100) !important;
}
.areaLocal{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SICSEN/Administracion/Sentencias.vue